import React, { useState } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import ProjectBoxOffer from "../Elements/ProjectBoxOffer";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import "./OffersStyles.css";

export default function Offers() {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);
  return (
    <Wrapper id="Offers" >
      <HeaderInfo >
        <div className="whiteBg">
          <div className="container">

            <h1 className="font40 extraBold textsLeft">{t("Offers")}</h1>
            <p className="fonts131">{t("OfferDesc")}</p>
            <p className="fonts131" style={{ marginTop: "50px" }}>
              {t("Eco")}
            </p>
          </div>
        </div>
      </HeaderInfo>
      <Accordion>
        <AccordionSummary
          aria-controls="panel1-content"
          id="panel1-header"
        >
          {expanded ? (
            <>
              <ProjectBoxOffer
                from={t("trajetOfferEcoDest5")}
                to="Paris"
                passengers={t("trajetOfferEco5")}
                prix="55 €"
              />
              <ProjectBoxOffer
                from="Paris"
                to={t("trajetOfferEcoDest5")}
                passengers={t("trajetOfferEco5")}
                prix="55 €"
              />
              <ProjectBoxOffer
                from="Paris"
                to={t("trajetOfferEcoDest1")}
                passengers={t("trajetOfferEco")}
                prix="75 €"
              />
            </>
          ) : (
            <ProjectBoxContainer>
              <div className="row fhjIPfs">
                <div className="col-xs-11 col-sm-4 col-md-4 col-xs-4">
                  <ProjectBoxOffer
                    from={t("trajetOfferEcoDest5")}
                    to="Paris"
                    passengers={t("trajetOfferEco5")}
                    prix="55€"
                  />
                </div>
                <div className="col-xs-11 col-sm-4 col-md-4 col-xs-4" >
                  <ProjectBoxOffer
                    from="Paris"
                    to={t("trajetOfferEcoDest5")}
                    passengers={t("trajetOfferEco5")}
                    prix="55 €"
                  />
                </div>
                <div className="col-xs-11 col-sm-4 col-md-4 col-xs-4" >
                  <ProjectBoxOffer
                    from="Paris"
                    to={t("trajetOfferEcoDest1")}
                    passengers={t("trajetOfferEco")}
                    prix="75 €"
                  />
                </div>
              </div>
            </ProjectBoxContainer>
          )}
        </AccordionSummary>
        <AccordionDetails>
          <div className="container">
            <div className="row textsLeft">
              <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                <ProjectBoxOffer
                  from={t("trajetOfferEcoDest1")}
                  to="Paris"
                  passengers={t("trajetOfferEco")}
                  prix="75 €"
                />
              </div>
              <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                <ProjectBoxOffer
                  from={t("trajetOfferEcoDest3")}
                  to="Paris"
                  passengers={t("trajetOfferEco3")}
                  prix="90 €"
                />
              </div>
              <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                <ProjectBoxOffer
                  from="Paris"
                  to={t("trajetOfferEcoDest4")}
                  passengers={t("trajetOfferEco4")}
                  prix="160 €"
                />
              </div>
            </div>
          </div>

          <div className="container">
            <HeaderInfo>
              <p className="fonts131" style={{ marginTop: "50px" }}>
                {t("Berline")}
              </p>
            </HeaderInfo>
            <div className="row textsLeft">
              <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                <ProjectBoxOffer
                  from={t("trajetOfferBerlineDest4")}
                  to="Paris"
                  passengers={t("trajetOfferEco5")}
                  prix="80 €"
                />
              </div>
              <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                <ProjectBoxOffer
                  from="Paris"
                  to={t("trajetOfferBerlineDest4")}
                  passengers={t("trajetOfferBerline4")}
                  prix="80 €"
                />
              </div>
              <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                <ProjectBoxOffer
                  from={t("trajetOfferBerlineDest1")}
                  to="Paris"
                  passengers={t("trajetOfferBerline1")}
                  prix="95 €"
                />
              </div>
              <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                <ProjectBoxOffer
                  from="Paris"
                  to={t("trajetOfferBerlineDest1")}
                  passengers={t("trajetOfferEco5")}
                  prix="95 €"
                />
              </div>
              <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                <ProjectBoxOffer
                  from={t("trajetOfferBerlineDest3")}
                  to="Paris"
                  passengers={t("trajetOfferEco5")}
                  prix="120 €"
                />
              </div>
              <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                <ProjectBoxOffer
                  from={t("trajetOfferBerlineDest5")}
                  to="Paris"
                  passengers={t("trajetOfferBerline5")}
                  prix="190 €"
                />
              </div>
            </div>
          </div>
          <div className="container">
            <HeaderInfo expandIcon={<ExpandMoreIcon />}>
              <p className="fonts131" style={{ marginTop: "50px" }}>
                {t("Van")}
              </p>
            </HeaderInfo >
            <div className="row textCenter">
              <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                <ProjectBoxOffer
                  from={t("trajetOfferVanDest4")}
                  to="Paris"
                  passengers={t("trajetOfferVan4")}
                  prix="90 €"
                />
              </div>
              <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                <ProjectBoxOffer
                  from="Paris"
                  to={t("trajetOfferVanDest4")}
                  passengers={t("trajetOfferVan4")}
                  prix="90 €"
                />
              </div>
              <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                <ProjectBoxOffer
                  from={t("trajetOfferVanDest1")}
                  to="Paris"
                  passengers={t("trajetOfferVan1")}
                  prix="140 €"
                />
              </div>
              <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                <ProjectBoxOffer
                  from="Paris"
                  to={t("trajetOfferVanDest1")}
                  passengers={t("trajetOfferEco5")}
                  prix="140 €"
                />
              </div>
              <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                <ProjectBoxOffer
                  from={t("trajetOfferVanDest3")}
                  to="Paris"
                  passengers={t("trajetOfferVan3")}
                  prix="160 €"
                />
              </div>
              <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                <ProjectBoxOffer
                  from={t("trajetOfferVanDest5")}
                  to="Paris"
                  passengers={t("trajetOfferVan5")}
                  prix="220 €"
                />
              </div>
            </div>
          </div>
        </AccordionDetails>
      </Accordion>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
  margin-top: 50px;
  padding-right: 0px;
  padding-left: 0px;
  @media (max-width: 860px) {
    width: 100%;
    .col-xs-12 {
      flex-basis: 100%;
      max-width: 100%;
    }  
  }
`;
const HeaderInfo = styled.div`
  @media (max-width: 860px) {
    text-align: center;
  }
`;
const ProjectBoxContainer = styled.div`
  display: flex;
  flex-direction: column; 
  gap: 20px; 
  @media (min-width: 860px) {
    flex-direction: row; 
    gap: 20px; 
    .fhjIPfs {
      margin-left: 45px;
      width: 1390px;
    }
  }
`;

